import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { sendAnalyticsEvent } from '../common/libs/googleAnalytics';

function Breadcrumbs({
  parentPages,
  currentPageTitle,
}: {
  parentPages: {
    title: string;
    href: string;
    gaLabel: string;
  }[];
  currentPageTitle: string;
}) {
  return (
    <Breadcrumb
      spacing="8px"
      separator={<ChevronRightIcon color="gray.500" />}
      fontSize="xs"
      opacity="0.8"
    >
      <BreadcrumbItem>
        <BreadcrumbLink
          href="/"
          onClick={() => sendAnalyticsEvent('breadcrumb', 'click', 'home')}
        >
          ホーム
        </BreadcrumbLink>
      </BreadcrumbItem>

      {parentPages.map(({ title, href, gaLabel }) => (
        <BreadcrumbItem key={title}>
          <BreadcrumbLink
            href={href}
            onClick={() => sendAnalyticsEvent('breadcrumb', 'click', gaLabel)}
          >
            {title}
          </BreadcrumbLink>
        </BreadcrumbItem>
      ))}

      <BreadcrumbItem isCurrentPage>
        <BreadcrumbLink cursor="default" textDecoration="underline">
          {currentPageTitle}
        </BreadcrumbLink>
      </BreadcrumbItem>
    </Breadcrumb>
  );
}

export default Breadcrumbs;
